import React, { useState, useEffect } from "react";
import * as XLSX from "xlsx";
import { db } from "../firebaseConfig";
import { collection, addDoc, getDocs } from "firebase/firestore";
import { getAuth } from "firebase/auth";
import ilIlceData from "../data/iller-ilceler.json";

const FirmaExcelYukle = () => {
  const [dosya, setDosya] = useState(null);
  const [progress, setProgress] = useState(0);
  const [hataDosyasiAktif, setHataDosyasiAktif] = useState(true);
  const [mevcutVergiNolar, setMevcutVergiNolar] = useState([]);

  useEffect(() => {
    const fetchVergiNolar = async () => {
      const snap = await getDocs(collection(db, "firms"));
      setMevcutVergiNolar(snap.docs.map((d) => d.data().vergiNo));
    };
    fetchVergiNolar();
  }, []);

  const handleDosyaSec = (e) => setDosya(e.target.files[0]);

  const handleYukle = async () => {
    if (!dosya) return alert("Lütfen bir Excel dosyası seçin.");
    const user = getAuth().currentUser;
    if (!user) return alert("Giriş yapmadan işlem yapılamaz!");

    const reader = new FileReader();
    reader.onload = async (e) => {
      const workbook = XLSX.read(e.target.result, { type: "binary" });
      const ws = workbook.Sheets[workbook.SheetNames[0]];
      const json = XLSX.utils.sheet_to_json(ws, { defval: "" });

      let hataliSatirlar = [];
      let basariliKayit = 0;

      if (json.length === 0) {
        alert("Excel dosyası boş veya hatalı şablon!");
        return;
      }

      const chunkSize = 50;
      for (let i = 0; i < json.length; i += chunkSize) {
        const parca = json.slice(i, i + chunkSize);

        for (let row of parca) {
          const firmaAdi = row["Firma Adı"]?.toString().trim();
          const vergiNo = row["Vergi No"]?.toString().trim();
          const kdvOraniStr = row["KDV Oranı"]?.toString().replace(",", ".").trim();
          const vergiDairesi = row["Vergi Dairesi"]?.toString().trim();
          const yetkili = row["Yetkili"]?.toString().trim();
          const telefon = row["Telefon"]?.toString().trim();
          const adres = row["Adres"]?.toString().trim();
          const il = row["İl"]?.toString().trim().toUpperCase();
          const ilce = row["İlçe"]?.toString().trim().toUpperCase();
          const aciklama = row["Açıklama"]?.toString().trim();

          const kdvOrani = parseFloat(kdvOraniStr);

          // ✅ Validasyon
          if (!firmaAdi || !vergiNo || isNaN(kdvOrani)) {
            hataliSatirlar.push({ ...row, "Hata Nedeni": "Zorunlu alanlar eksik" });
            continue;
          }
          if (!/^\d{10,11}$/.test(vergiNo)) {
            hataliSatirlar.push({ ...row, "Hata Nedeni": "Vergi No 10-11 haneli olmalı" });
            continue;
          }
          if (kdvOrani < 1 || kdvOrani > 100) {
            hataliSatirlar.push({ ...row, "Hata Nedeni": "KDV 1-100 arası olmalı" });
            continue;
          }
          if (mevcutVergiNolar.includes(vergiNo)) {
            hataliSatirlar.push({ ...row, "Hata Nedeni": "Bu vergi numarası zaten kayıtlı" });
            continue;
          }
          const ilObj = ilIlceData.find((i) => i.il.toUpperCase() === il);
          if (!ilObj) {
            hataliSatirlar.push({ ...row, "Hata Nedeni": "İl bulunamadı" });
            continue;
          }
          if (!ilObj.ilceler.map((x) => x.toUpperCase()).includes(ilce)) {
            hataliSatirlar.push({ ...row, "Hata Nedeni": "İlçe bulunamadı" });
            continue;
          }

          // ✅ Firestore'a ekleme
          await addDoc(collection(db, "firms"), {
            firmaAdi,
            vergiNo,
            kdvOrani,
            vergiDairesi,
            yetkili,
            telefon,
            adres,
            il,
            ilce,
            aciklama,
            active: true,
            createdAt: new Date(),
            createdBy: user.email,
          });

          basariliKayit++;
        }

        const yeniProgress = Math.min(100, Math.round(((i + chunkSize) / json.length) * 100));
        setProgress(yeniProgress);
        await new Promise((r) => setTimeout(r, 200));
      }

      alert(
        `✅ Yükleme tamamlandı\n✔ Başarıyla eklenen: ${basariliKayit}\n❗ Hatalı satır: ${hataliSatirlar.length}`
      );
      setProgress(0);

      if (hataDosyasiAktif && hataliSatirlar.length > 0) {
        const wb = XLSX.utils.book_new();
        const ws = XLSX.utils.json_to_sheet(hataliSatirlar);
        XLSX.utils.book_append_sheet(wb, ws, "Hatalar");
        XLSX.writeFile(wb, "firma_yukleme_hatalari.xlsx");
      }
    };
    reader.readAsBinaryString(dosya);
  };

  const handleOrnekIndir = () => {
    const workbook = XLSX.utils.book_new();
    const veri = [
      {
        "Firma Adı": "ACME A.Ş.",
        "Vergi No": "1234567890",
        "KDV Oranı": "18",
        "Vergi Dairesi": "ÇANKAYA",
        "Yetkili": "Ali Veli",
        "Telefon": "03120000000",
        "Adres": "ANKARA MAH. NO:1",
        "İl": "ANKARA",
        "İlçe": "ÇANKAYA",
        "Açıklama": "Numune Firma",
      },
    ];
    const ws = XLSX.utils.json_to_sheet(veri);
    XLSX.utils.book_append_sheet(workbook, ws, "Firmalar");
    XLSX.writeFile(workbook, "ornek_firma.xlsx");
  };

  return (
    <div style={{ padding: 20, maxWidth: 800, margin: "auto" }}>
      <h2 style={{ fontSize: "1.5rem", fontWeight: "bold", color: "#4f46e5", marginBottom: 20 }}>
        Excel ile Firma Yükle
      </h2>
      <input type="file" accept=".xlsx,.xls" onChange={handleDosyaSec} style={{ marginBottom: 10 }} />
      <div style={{ marginBottom: 10 }}>
        <label>
          <input
            type="checkbox"
            checked={hataDosyasiAktif}
            onChange={(e) => setHataDosyasiAktif(e.target.checked)}
          />{" "}
          Hata Dosyası Oluştur
        </label>
      </div>
      <div style={{ display: "flex", gap: 10 }}>
        <button
          onClick={handleYukle}
          style={{
            backgroundColor: "#16a34a",
            color: "white",
            padding: "8px 16px",
            borderRadius: 6,
            border: "none",
            cursor: "pointer",
          }}
        >
          Yükle
        </button>
        <button
          onClick={handleOrnekIndir}
          style={{
            backgroundColor: "#2563eb",
            color: "white",
            padding: "8px 16px",
            borderRadius: 6,
            border: "none",
            cursor: "pointer",
          }}
        >
          Örnek Şablon İndir
        </button>
      </div>
      {progress > 0 && (
        <div style={{ marginTop: 20 }}>
          <div
            style={{
              backgroundColor: "#e5e7eb",
              height: 20,
              borderRadius: 6,
              overflow: "hidden",
            }}
          >
            <div
              style={{
                width: `${progress}%`,
                height: "100%",
                backgroundColor: "#4f46e5",
                transition: "width 0.3s",
              }}
            />
          </div>
          <p style={{ marginTop: 5 }}>{progress}% tamamlandı...</p>
        </div>
      )}
    </div>
  );
};

export default FirmaExcelYukle;
